export const SCREEN_STATUS_COLORS = {
  online: '#16a34a',
  offline: '#dc2626',
  onlineGlow: 'rgba(34,197,94,0.5)',
  offlineGlow: 'rgba(220,38,38,0.4)',
};

export const DAY_ORDER = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];

export const DAY_LABEL: Record<string, string> = {
  MONDAY: 'Mon', TUESDAY: 'Tue', WEDNESDAY: 'Wed', THURSDAY: 'Thu',
  FRIDAY: 'Fri', SATURDAY: 'Sat', SUNDAY: 'Sun',
};

export const EDIT_SCREEN_EDITABLE_FIELDS = new Set([
  'price',
  'sizeHeight',
  'sizeWidth',
  'orientation',
  'height',
  'width',
  'deviceImage',
  'loopDuration',
  'slotTimeInSec',
  'numberOfSlots',
  'category',
  'networkName',
  'screenOnDays',
  'screenOnTime',
]);

export const LIVE_PREVIEW_CONFIG = {
  CARD_W: 120,
  CARD_H: 90,
  STACK_STEP: 5,
  CAMPAIGN_COLORS: [
    '#1976d2',
    '#388e3c',
    '#f57c00',
    '#7b1fa2',
    '#c62828',
    '#00838f',
    '#4e342e',
    '#1565c0',
    '#ad1457',
    '#2e7d32',
    '#ef6c00',
    '#6a1b9a',
  ],
};
